/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiTransformFromJSON(json) {
    return StreemApiTransformFromJSONTyped(json, false);
}
export function StreemApiTransformFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'position': !exists(json, 'position') ? undefined : json['position'],
        'rotation': !exists(json, 'rotation') ? undefined : json['rotation'],
        'scale': !exists(json, 'scale') ? undefined : json['scale'],
    };
}
export function StreemApiTransformToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'position': value.position,
        'rotation': value.rotation,
        'scale': value.scale,
    };
}
//# sourceMappingURL=StreemApiTransform.js.map